import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { PropretyAttributes } from "../../decorators/EntityDecorators";
import { Register } from "../../decorators/DependencyInjectionRegistreyDecorators";


@Register({
  isModelEntity: true, namespace: 'Tenant' , entityName: 'FSTREAM_Image' // optionnel car par defaut utilise le nom de classe
})
export class FSTREAM_Image extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn,
      IPropretyAttribute.Required
    ],
    PropretyDisplayName: "Raw Data Path"
  })
  rawData_Path?: string;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn,
      IPropretyAttribute.Required
    ],
    PropretyDisplayName: "Thumbnail Path"
  })
  thumbnail_Path?: string;


  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn,
      IPropretyAttribute.Required
    ],
    PropretyDisplayName: "Mime Type"
  })
  mimeType?: string;

  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.FilterColumn,
      IPropretyAttribute.SortColumn,
      IPropretyAttribute.Required
    ],
    PropretyDisplayName: "File Name"
  })
  fileName?: string;

  // Navigation properties ...??????
  

  GetType(): IEntityMetaData {
    return FSTREAM_Image.getMetaData();
  }
}
